import { ASSET_TYPE_TO_AI_INPUTS_TYPENAME } from '../constants/assetTypes';
export const getName = typedInputs => typedInputs && 'name' in typedInputs ? typedInputs.name : undefined;
const getAiInputSegment = typedInputs => typedInputs && 'segmentIdentifier' in typedInputs ? typedInputs.segmentIdentifier : undefined;
export const getSegmentType = typedInputs => {
  var _getAiInputSegment;
  return (_getAiInputSegment = getAiInputSegment(typedInputs)) === null || _getAiInputSegment === void 0 ? void 0 : _getAiInputSegment.segmentType;
};
export const getSegmentId = typedInputs => {
  var _getAiInputSegment2;
  return (_getAiInputSegment2 = getAiInputSegment(typedInputs)) === null || _getAiInputSegment2 === void 0 ? void 0 : _getAiInputSegment2.implementationObjectId;
};
export const createExecutionInputs = inputs => Object.assign({}, inputs, {
  __typename: ASSET_TYPE_TO_AI_INPUTS_TYPENAME[inputs.assetCoordinates.source]
});